import {Injectable} from "@angular/core";
import {
    GetPostalCodeFromCurrentLocationUseCase
} from "@app/core/delivery-point/application/get-postal-code-from-current-location.use-case";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class PostalCodeViewModel {
    constructor(
        private  getPostalCodeFromCurrentLocationUseCase:GetPostalCodeFromCurrentLocationUseCase
    ) {
    }

    getPostalCodeFromCurrentLocation(): Observable<string> {
        return this.getPostalCodeFromCurrentLocationUseCase.execute();
    }
}